'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useLookupsStore } from '@repo/store/useLookupsStore'

export const PhoneTypeSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required
}) => {
  const { fetchPhoneTypes, phoneTypes } = useLookupsStore()
  const [options, setOptions] = useState(testData || phoneTypes || [])

  useEffect(() => {
    if (testData) return
    setOptions(phoneTypes || [])
  }, [testData, phoneTypes])

  useEffect(() => {
    if (testData || phoneTypes?.length) return
    fetchPhoneTypes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, phoneTypes])

  return (
    <div data-testid="PhoneTypeSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label="Phone type"
        onChange={onChange}
        labelKey="description"
        valueKey="phoneTypeId"
        items={options}
        value={value}
        searchable
        idLabelKey="phoneTypeId"
        showIdInResults={false}
        name="phoneType"
        size={size}
        required={required}
      />
    </div>
  )
}

PhoneTypeSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool
}
